module.exports = __webpack_public_path__ + "img/old.24dd9619.png";